// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.UploadListItem {
  display: flex;
  width: 100%;
  padding: 12px 0;
  gap: 16px;
}
.UploadListItem[data-isNotProcessed=true] span {
  color: var(--color_neutral_500);
}
.UploadListItem [data-disabled=true] {
  pointer-events: none;
}
.UploadListItem span {
  color: var(--color_neutral_0);
  font-size: 14px;
  font-weight: 400;
}
.UploadListItem-column {
  display: flex;
  align-items: center;
}
.UploadListItem-column.right {
  justify-content: flex-end;
  text-align: right;
}
.UploadListItem-filename {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/documents/upload-list-item/upload-list-item.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AAeF;AAZI;EACE,+BAAA;AAcN;AAVE;EACE,oBAAA;AAYJ;AATE;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;AAWJ;AARE;EACE,aAAA;EACA,mBAAA;AAUJ;AARI;EACE,yBAAA;EACA,iBAAA;AAUN;AANE;EDjCA,oBAAA;EACA,aCiCsB;EDhCtB,qBCgCsB;ED/BtB,4BAAA;EACA,gBAAA;EACA,qBC6ByB;AAa3B","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.UploadListItem {\n  display: flex;\n  width: 100%;\n  padding: 12px 0;\n  gap: 16px;\n\n  &[data-isNotProcessed='true'] {\n    span {\n      color: var(--color_neutral_500);\n    }\n  }\n\n  [data-disabled='true'] {\n    pointer-events: none;\n  }\n\n  span {\n    color: var(--color_neutral_0);\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  &-column {\n    display: flex;\n    align-items: center;\n\n    &.right {\n      justify-content: flex-end;\n      text-align: right;\n    }\n  }\n\n  &-filename {\n    @include line-clamp(1, break-all);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
